
import { useEffect } from "react";
import CanonicalTag from "@/components/CanonicalTag";

const UDAAIDesigner = () => {
  useEffect(() => {
    // Add the widget script to the page
    const scriptElement = document.createElement("script");
    scriptElement.src = 'https://widget.homedesigns.ai/embed.js?id=1859329';
    scriptElement.async = true;
    document.body.appendChild(scriptElement);

    // Cleanup function to remove script when component unmounts
    return () => {
      const existingScript = document.querySelector('script[src*="widget.homedesigns.ai"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div>
      <CanonicalTag url="https://www.udaadu.com/uda-ai-designer" />
      <div id="homedesigns-widget-1859329"></div>
    </div>
  );
};

export default UDAAIDesigner;
